import PagesByCategory from './Components/PagesByCategory';
import PagesByCategoryCount from './Components/PagesByCategoryCount';
import PagesByStatus from './Components/PagesByStatus';
import UserCountByRole from './Components/UserCountByRole';
import UserCountByRoleCount from './Components/UserCountByRoleCount';
import UserCountByStatus from './Components/UserCountByStatus';
import { Helmet } from 'react-helmet';
import { getSetting } from '../Settings/ApiSettings';
import { useQuery } from 'react-query';

export default function Dashboard(props) {
  return (
    <>
      <Helmet>
        <title>  CMS | Dashboard</title>
      </Helmet>

      {/* Looker Studio Report Section */}
      <div className="mb-12">
        <div className="mb-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <span className="text-2xl">📊</span>
              <div>
                <h2 className="text-2xl font-bold text-gray-900">Advanced Analytics Report</h2>
                <p className="text-gray-600">Comprehensive data visualization and insights</p>
              </div>
            </div>
            <div className="flex items-center space-x-2">
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                <span className="w-2 h-2 bg-blue-400 rounded-full mr-1.5"></span>
                Interactive Report
              </span>
            </div>
          </div>
        </div>
         <div className="bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden">
           <iframe
             src="https://datastudio.google.com/embed/reporting/b055745a-88db-4908-b629-5999afdb29cd/page/kIV1C"
             width="100%"
             height="600"
             frameBorder="0"
             style={{ border: 0 }}
             allowFullScreen
             sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
             className="w-full"
             title="Advanced Analytics Report"
           />
         </div>
      </div>
      <div className="grid  grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <PagesByCategoryCount />
        <UserCountByRoleCount />
      </div>
      <div className="grid grid-cols-2 gap-6">
        <UserCountByRole />
        <UserCountByStatus />
        <PagesByCategory />
        <PagesByStatus />
      </div>
    </>
  );
}
